namespace advisorop.components.advisor {
    
    export class ProposalListController{

        public proposals;
        public dgProposalsSettings;        

        constructor(private advisorService: services.AdvisorService) {

            this.dgProposalsSettings = {
                export: {
                    enabled: true,
                    fileName: "Proposals"
                },
                bindingOptions: {
                    dataSource: "vm.proposals"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                stateStoring: {
                    enabled: true,
                    type: "localStorage",
                    storageKey: "dgProposalsSettings"
                },
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,                            
                columns: [

                    { dataField: 'description', caption: 'Description', cellTemplate: 'colDescription', visible: true },
                    { dataField: 'investor.fullName', caption: 'Investor', width: 160 },
                    { dataField: 'investor.contactFullName', caption: 'Investor contact', visible: false },
                    { dataField: 'investor.contactEmail', caption: 'E-mail', visible: true },
                    { dataField: 'investmentModelNames', caption: 'Invest. models', visible: true},
                    { dataField: 'amount', caption: 'Amount', format: { type: 'fixedPoint', precision: 2 }, visible: true, width: 120},
                    { dataField: 'rtq.fullDescription', caption: 'Risk Tolerance', visible: true, width: 120 },
                    { dataField: 'dateCreate', caption: 'Created', dataType:'date', format:'shortDate', visible: true, width: 80 },
                    { dataField: 'id', caption: '#', cellTemplate: 'btnActions', width: 150 }                    
                ]
            };
        }

        loadProposals(): void {
            this.advisorService.getProposals().success((data) => {
                this.proposals = data;
            }).error((data, status) => {
                toastr.error("Proposals cannot be loaded. ERROR " + status + ":" + data);
            });
        };
        
        $onInit(): void {
            this.loadProposals();
        }
        
    }
    
    class ProposalList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                //proposals: "<"
            };
            this.controller = ["advisorService", ProposalListController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/proposal-list.html';
        }
    }
    angular.module(Constants.APP).component("proposalList", new ProposalList());

}